import React, { useState,useContext,useEffect,useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import BreadCrumb from "./BreadCumb";
import { Outlet } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import ProfileService from "./Services/ProfileService";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
export default function MyProfile(){
    const { logout } = useContext(AuthContext);
    const [nameOfUser, setNameOfUser] = useState('');
    const patientUserId = localStorage.getItem('userId');
const [userName, setUserName] = useState('');
const [isLogout,setIsLogout] = useState(false);
const [gender, setGender] = useState('');
const [age, setAge] = useState('');
const [profilePhotoCurrent,setProfilePhotoCurrent] = useState('');
// Query for PatientUser data
  const { data: patientUserData } = useQuery({
    queryKey: ['patientUserData'],
    queryFn: async () => {
      const response = await ProfileService.getPatientUserByPatientUserId(patientUserId);
      return response;
    },
  });
  const patientUserDataReports = useMemo(
    () => patientUserData?.data?.data ?? {},
    [patientUserData]
  );
  const calculateAge = (dobString) => {
  if (!dobString) return "";

  const dob = new Date(dobString); // yyyy-mm-dd
  const today = new Date();

  let years = today.getFullYear() - dob.getFullYear();
  let months = today.getMonth() - dob.getMonth();

  // Adjust if birthday month not reached
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust if birthday day not reached in current month
  if (today.getDate() < dob.getDate()) {
    months--;
    if (months < 0) {
      months = 11;
      years--;
    }
  }

  return `${years} years ${months} months`;
};

  useEffect(() => {
      if (patientUserDataReports) {
        setNameOfUser(patientUserDataReports.name || '');
        setGender(patientUserDataReports.gender || '');
        setUserName(patientUserDataReports.userName || '');
        setAge(calculateAge(patientUserDataReports.dob) || '');
        setProfilePhotoCurrent(patientUserDataReports.profilePhoto);
        // Profile photo would be a URL or something, but for upload, handle separately
      }
    }, [patientUserDataReports]);
    const navigate = useNavigate();

    const handleLogout = async (e) => {
      setIsLogout(true);
    e.preventDefault();
    try {
      const result = await logout();

      console.log("Logout success:", result);
      navigate("/");
    } catch (err) {
      console.error("Logout error in component:", err);
    } finally {
         setIsLogout(false);
    }
  };
    const titles = useState(localStorage.getItem('titles'));
    return (
        <div>
            <BreadCrumb title={titles}/>
        {/* Page Content */}
<div className="content">
  <div className="container">
    <div className="row">
      {/* Profile Sidebar */}
      <div className="col-lg-4 col-xl-3 theiaStickySidebar">
        {/* Profile Sidebar */}
        <div className="profile-sidebar patient-sidebar profile-sidebar-new">
          <div className="widget-profile pro-widget-content">
            <div className="profile-info-widget">
              <a href="/patient-settings" className="booking-doc-img" onClick={()=>{localStorage.setItem('titles','Settings')}}>
                <img src={`${serverConfig.BASE_URL}/uploads/patientProfiles/${profilePhotoCurrent}`} alt="User " 
                onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/user12.jpg";
  }}/>
              </a>
              <div className="profile-det-info">
                <h3><a href="/patient-settings" onClick={()=>{localStorage.setItem('titles','Settings')}}>{nameOfUser}</a></h3>
                <div className="patient-details">
                  <h5 className="mb-0">User Name : {userName}</h5>
                </div>
                <span>{gender} <i className="fa-solid fa-circle" /> {age}</span>
              </div>
            </div>
          </div>
          <div className="dashboard-widget">
            <nav className="dashboard-menu">
              <ul>
                <li className={(localStorage
                    .getItem('titles').toString()==="Dashboard")?"active":""}>
                  <a href="/patient-dashboard" onClick={()=>{localStorage.setItem('titles','Dashboard')}}>
                    <i className="isax isax-category-2" />
                    <span>Dashboard</span>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Appointments")?"active":""}>
                  <a href="/patient-appointments" onClick={()=>{localStorage.setItem('titles','Appointments')}}>
                    <i className="isax isax-calendar-1" />
                    <span>My Appointments</span>
                  </a>
                </li>
                {/* <li className={(localStorage
                    .getItem('titles').toString()==="Favourites")?"active":""}>
                  <a href="/patient-favourites" onClick={()=>{localStorage.setItem('titles','Favourites')}}>
                    <i className="isax isax-star-1" />
                    <span>Favourites</span>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Dependent")?"active":""}> 
                  <a href="/patient-dependent" onClick={()=>{localStorage.setItem('titles','Dependent')}}>
                    <i className="isax isax-user-octagon" />
                    <span>Dependants</span>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Medical Reports")?"active":""}>
                  <a href="/patient-medical-records" onClick={()=>{localStorage.setItem('titles','Medical Reports')}}>
                    <i className="isax isax-note-21" />
                    <span>Medical Records</span>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Accounts")?"active":""}>
                  <a href="/patient-accounts" onClick={()=>{localStorage.setItem('titles','Accounts')}}>
                    <i className="isax isax-wallet-2" />
                    <span>Wallet</span>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Invoices")?"active":""}>
                  <a href="/patient-invoices" onClick={()=>{localStorage.setItem('titles','Invoices')}}>
                    <i className="isax isax-document-text" />
                    <span>Invoices</span>
                  </a>
                </li>																																				
                <li className={(localStorage
                    .getItem('titles').toString()==="Chat")?"active":""}>
                  <a href="/patient-chat" onClick={()=>{localStorage.setItem('titles','Chat')}}>
                    <i className="isax isax-messages-1" />
                    <span>Message</span>
                    <small className="unread-msg">7</small>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Medical-Details")?"active":""}>
                  <a href="/patient-medical-details" onClick={()=>{localStorage.setItem('titles','Medical-Details')}}>
                    <i className="isax isax-note-1" />
                    <span>Vitals</span>
                  </a>
                </li>
                <li className={(localStorage
                    .getItem('titles').toString()==="Settings")?"active":""}>
                  <a href="/patient-settings" onClick={()=>{localStorage.setItem('titles','Settings')}}>
                    <i className="isax isax-setting-2" />
                    <span>Settings</span>
                  </a>
                </li> */}
                <li>
                  {/* <a> */}
                  <a href="#!" onClick={handleLogout} disabled={isLogout}>
                    <i className="isax isax-logout" />
                    <span>{(isLogout)?"Loading ...":"Logout"}</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        {/* /Profile Sidebar */}
      </div>
      {/* / Profile Sidebar */}
     <Outlet/>
    </div>
  </div>
</div>		
{/* /Page Content */}
</div>
    )
}